import {useCookies} from 'react-cookie';

const flsId = 'fls_id';

const Logout = () => {
  const [_cookie, _setCookie, removeCookie] = useCookies([flsId]);
  const handleLogout = () => {
    removeCookie(flsId);
  };

  return <button type="button" className="btn btn-primary" onClick={handleLogout}>Logout</button>;
};

const Register = () => {
  const handleRegister = () => {
    window.location.href = '/register';
  };

  return <button type="button" className="btn btn-primary" onClick={handleRegister}>Register</button>;
};

const Home = () => {
  const [cookies] = useCookies([flsId]);
  return cookies.fls_id
    ? (
      <div className="row justify-content-between">
        <h2>Current flashy contact id: ${cookies.fls_id}</h2>
        <div className="col-4">
          <Logout/>
        </div>
      </div>
    )
    : (
      <div className="row justify-content-between">
        <div className="col-4">
          <Register/>
        </div>
      </div>
    );
};

export default Home;